const _import = require(`../config/_import_${process.env.NODE_ENV}`)
export default _import


// WEBPACK FOOTER //
// ./src/router/config/index.js